import * as React from 'react';
import { memo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheveronDown = props => /*#__PURE__*/_jsx("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32",
  className: "svg-icon " + (props.className || ''),
  children: /*#__PURE__*/_jsx("path", {
    d: "M14.001 23.999 16 25.998l16-16-3.999-3.999L16 17.997 3.999 5.999 0 9.998z"
  })
});
const Memo = /*#__PURE__*/memo(SvgCheveronDown);
export default Memo;